import { StoreCore, createStore } from "@priolo/jon"
import alertApi from "api/alerts"
import { FetchPayload } from "stores/cycle/types"
import farmSo from "stores/farm"
import growUnitSo from "stores/growUnit"
import { LastDateRange } from "stores/planner/utils/fetch"
import { Alert } from "types/Alert"
import { haveValueDateRange, normalizeDateRanges } from "utils"



export enum SHOW_MODE {
	BY_DATE = "date",
	BY_SEVERITY = "severity",
}

const setup = {

	state: {
		all: <Alert[]>null,
		select: <Alert>null,
		isDetailOpen: false,
		/** serve per evitare caricamenti inutili */
		lastFarmId: <number>null,
	},

	getters: {
	},

	actions: {
		/** recupera dal BE gli ALERTs */
		fetch: async (payload: FetchPayload, store?: AlertStore) => {

			// controllo ci siano tutti i dati
			const farmId = payload?.farmId ?? growUnitSo.state.lastFarmId
			const dateRange = normalizeDateRanges([payload?.dateRange, LastDateRange])
			if (!farmId || !haveValueDateRange(dateRange)) return

			// a sto punto carico di brutto...
			let items = []
			try {
				items = (await alertApi.indexByFarm(farmId, dateRange))?.data ?? []
			} catch (e) {
				console.error("Error fetching alerts", e)
			}
			store.state.lastFarmId = farmId

			// se devo aggiungere...
			if (payload.add) {
				store.setAll([...(store.state.all ?? []), ...items])
			// ...altrimenti sostituisco tutto
			} else {
				store.setAll(items)
			}
		},
		fetchIfVoid: async (farmId: number, store?: AlertStore) => {
			if (store.state.all != null && farmId == store.state.lastFarmId) return
			store.fetch({
				farmId,
				dateRange: LastDateRange,
			})
		},
		fetchAndSelect: async (uuid: string, store?: AlertStore) => {
			const farmId = farmSo.state.select?.id
			if (farmId == null) return
			const { data: alert } = await alertApi.showByFarm(farmId, uuid)
			store.setSelect(alert)
		},
	},

	mutators: {
		setAll: (all: Alert[]) => ({ all }),
		setSelect: (select: Alert) => ({ select }),
		setIsDetailOpen: (isDetailOpen: boolean) => ({ isDetailOpen }),
	},
}



export type AlertState = typeof setup.state
export type AlertGetters = typeof setup.getters
export type AlertActions = typeof setup.actions
export type AlertMutators = typeof setup.mutators
export interface AlertStore extends StoreCore<AlertState>, AlertGetters, AlertActions, AlertMutators {
	state: AlertState
}
const alertSo = createStore(setup) as AlertStore
export default alertSo
